import { Typography, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h1.fontSize,
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(3),
  fontWeight: 700,
}))

export const PollContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  border: '1px solid #E5E6EB',
  width: '100%',
  maxWidth: '800px',
  margin: '0 auto',
}))

export const PollInstructions = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  marginBottom: theme.spacing(1),
}))

export const PollInstructionsSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  color: theme.colors.neutral.darkGray,
  marginBottom: theme.spacing(3),
}))

export const PaddedContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  margin: '0 auto',
}))

export const ButtonContainer = styled(Box)(({ theme }) => ({
  boxShadow: '0px -6px 20px -6px #0C62FB29;',
  padding: '16px 24px',
  justifyContent: 'center',
  display: 'flex',
  marginTop: '434px',
}))

export const ButtonInnerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '342px',
  [theme.breakpoints.up('desktop')]: {
    maxWidth: '800px',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}))

export const LoaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  marginTop: theme.spacing(3),
}));
